app.controller('notificationController', function($http, $scope, $rootScope, $stateParams, $location, dataService, pageConfig, pageHandler, $timeout, $controller) {
    $(".dropdown-menu").click(function(e){
        e.stopPropagation();
    });

    $scope.goToNotification = function(item){
        var current_page = $scope.appState.page;
        if(item.notification_type == 'library')
        {
            if(current_page == 'library'){
                //Trigger event
                $rootScope.$broadcast('ViewLibraryItem', {'target_item': item.library_id});
            }
            else{
                //Navigate to that page and pass the target record id in the root scope
                $rootScope.target_item = item.library_id;
                $scope.goToPage('library', {'target_item': item.library_id});
            }
        }
        // e.stopPropagation();
        return true;
    }

    $('.notification.dropdown').on('hide.bs.dropdown', function () {
        // do something…
        $rootScope.unreadFlag = false;
        $scope.updateLastReadNotifications();
    });

    //Keep this in the root scope since it needs to be shared between multiple instances of the controller
    $rootScope.userNotifications = [];
    $rootScope.lastRead = 0;
    $rootScope.unreadFlag = false;

    //Load the data for the notifications
    $rootScope.getNewNotifications = function () {
        $rootScope.unreadFlag = false;
        //Get the new list of notifications
        var appState = angular.copy($scope.appState);
        dataService.getData('notifications/get_new_user_notifications', {'app_state' : appState} , 'POST')
        .then(function(response) {
            if(typeof(response) !== 'undefined')
            {
                $rootScope.userNotifications = response.user_notifications;
                $rootScope.lastRead = response.notification_last_read;

                //Go through each notifications and identify if any are unread
                angular.forEach($rootScope.userNotifications, function(value, key){
                    if(value.notification_date > $rootScope.lastRead)
                    {
                        $rootScope.unreadFlag = true;
                        return false;
                    }
                });
            }
        });

        //Recursively call the function
        $timeout(function(){
            // console.log('Fetch new notifications');
            $rootScope.getNewNotifications();
        }, 60000);
    }

    if(!$rootScope['notificationsLoop'])
    {
        //Initiate the notifications loop
        $rootScope['notificationsLoop'] = true;
        $rootScope.getNewNotifications();
    }

    $scope.getDate = function(timestamp){
        var date = new Date(timestamp * 1000);
        var datevalues = ('0' + date.getDate()).slice(-2) + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + date.getFullYear() + ' ' + ('0' + (date.getHours() + 1)).slice(-2) + ':' + ('0' + (date.getMinutes() + 1)).slice(-2);
        return datevalues;
    }

    $scope.updateLastReadNotifications = function () {
        //Send a request to update the user's last read notification time
        var appState = angular.copy($scope.appState);
        dataService.getData('notifications/update_user_notification_last_read', {'app_state' : appState} , 'POST')
        .then(function(response) {
            if(typeof(response) !== 'undefined')
            {
                //Success
            }
        });
    }

});

app.controller('notificationSettingsController', function($http, $scope, $rootScope, $stateParams, $location, dataService, pageConfig, pageHandler, $timeout, $modal, $anchorScroll, $controller) {
    $(".dropdown-menu").click(function(e){
        e.stopPropagation();
    });

    //Get the new list of notifications
    $rootScope.categoryList = {};
    $rootScope.overalTypesInitialValue = {};//All selected brands
    $rootScope.allBrandsInitialValue = [];//All selected brands
    $rootScope.overalTypes = {};//All selected brands
    $rootScope.allBrands = [];//All selected brands
    $rootScope.frequencyInitial = '';
    $rootScope.frequency = '';

    $rootScope.getSettingsData = function () {
        var appState = angular.copy($scope.appState);
        // var types_list = [];
        var brands_list = [];
        dataService.getData('notifications/get_user_notification_settings', {'app_state' : appState} , 'POST')
        .then(function(response) {
                if(typeof(response) !== 'undefined')
                {
                    var data = typeof response['data'] !== 'undefined' ? response['data']:{};
                    // console.log(response);
                    $rootScope.notificationTypes = typeof data['notification_types'] !== 'undefined'? data['notification_types']: {};
                    $rootScope.categoryList = typeof data['user_notification_settings'] !== 'undefined'? data['user_notification_settings']: {};

                    angular.forEach($rootScope.notificationTypes, function(type, type_key){
                        angular.forEach($rootScope.categoryList, function(category, category_key){
                            if(category.category_id == 0){
                                //Add to overall items
                                var temp = {
                                    'category_id': category.category_id,
                                    'category_name': category.category_name,
                                    'type': type,
                                    'selected': category[type+'_notification']
                                }
                                $rootScope.overalTypes[type] = temp;

                                $rootScope.frequency = category['notification_frequency'];
                                return false;
                            }
                        });
                    });
                    $rootScope.overalTypesInitialValue = angular.copy($rootScope.overalTypes);
                    $rootScope.frequencyInitial = angular.copy($rootScope.frequency);

                    angular.forEach($rootScope.notificationTypes, function(type, type_key){
                        angular.forEach($rootScope.categoryList, function(category, category_key){
                            if(category.category_id !== 0){
                                if(type === 'library'){
                                    var temp_overall = $rootScope.overalTypes[type];
                                    if(temp_overall.selected){
                                        category['library_notification'] = temp_overall.selected;
                                    }
                                    brands_list.push(category);
                                }
                            }
                        });
                    });


                    $rootScope.allBrands = brands_list;
                    $rootScope.allBrandsInitialValue = angular.copy(brands_list);//Keep a backup
                }
            }
        );
    }

    $rootScope.getSettingsData();

    $rootScope.settingsChanged = function () {
        var changed = false;

        angular.forEach($rootScope.allBrands, function(category, category_key){
            //check if brand id matches
            if(category['library_notification'] !== $rootScope.allBrandsInitialValue[category_key]['library_notification']){
                changed = true;
            }
        });

        angular.forEach($rootScope.overalTypes, function(type, type_key){
            //check if brand id matches
            if(type['selected'] !== $rootScope.overalTypesInitialValue[type_key]['selected']){
                changed = true;
            }
        });
/*console.log($rootScope.frequencyInitial);
console.log($rootScope.frequency);
console.log($scope.frequency);
        if($rootScope.frequencyInitial !== $scope.frequency){
            $rootScope.frequency = angular.copy($scope.frequency);
            changed = true;
        }*/

        if($rootScope.frequencyInitial !== $rootScope.frequency){
            changed = true;
        }
        return changed;
    }

    $rootScope.resetSettings = function () {
        // console.log($scope);
        $rootScope.allBrands = angular.copy($rootScope.allBrandsInitialValue);
        $rootScope.overalTypes = angular.copy($rootScope.overalTypesInitialValue);
        $rootScope.frequency = angular.copy($rootScope.frequencyInitial);
        $scope.frequency = angular.copy($rootScope.frequencyInitial);
    }

    $rootScope.updateSettings = function () {
        //Transform the data for submission
        var settings = {};

        angular.forEach($rootScope.overalTypes, function(type, type_key){
            if(type.type == 'library'){
                var all_selected = true;
                var all_selected_items = [];
                angular.forEach($rootScope.allBrands, function(category, category_key){
                    if(category['library_notification']){

                        //Add to overall items
                        var temp = {
                            'category_id': category.category_id,
                            'category_name': category.category_name,
                            'type': type.type,
                            'selected': category[type+'_notification']
                        }
                        all_selected_items.push(temp);
                    }
                    else{
                        all_selected = false;
                    }
                });

                if(all_selected){
                    //Input the overall entry
                    settings[type_key] = [type];
                }
                else{
                    //Add the selected items only
                    settings[type_key] = all_selected_items;
                }
            }
            else{
                if(type.selected){
                    //Add type to settings
                    settings[type_key] = [type];
                }
            }

        });
        // console.log(settings);

        //Submit settings to the back end
        dataService.getData('notifications/save_notification_settings', {'user_notification_settings': settings, 'user_notification_frequency': $scope.frequency}, 'POST')
        .then(function(response) {
            //
            $scope.getSettingsData();
        });
    }
});
